import React from "react";
import styles from "./styles.module.scss";
import { useSurvey } from "./hooks/useSurvey";
import { Loading } from "../../boxes/Loading/Loading";
import { Match } from "../../utilities/fp";
import { Error } from "./shared/Error";
import { Content } from "./boxes/Content";

export function Survey() {
  var { isLoading, isError } = useSurvey();

  return (
    <div className={styles.root}>
      {Match.of(true)
        .on(isLoading, () => <Loading center />)
        .on(isError, () => <Error />)
        .or(<Content />)
        .join()}
    </div>
  );
}
